import { Controller } from "@hotwired/stimulus";

// La trombone du coach GO4LEARN — prototype « Web et mobile interactifs », route `coach`.
//
// ⚠️ Il ne fait QUE l'affordance : choisir, montrer, retirer. Le téléversement est celui
// du formulaire (`multipart`), et le refus de format est dit par le SERVEUR
// (`AiMessage.acceptable_photo?`) — une seconde règle ici divergerait de la première au
// premier ajustement de plafond.
export default class extends Controller {
  static targets = ["input", "chip", "name"];

  open() {
    this.inputTarget.click();
  }

  picked() {
    const fichier = this.inputTarget.files?.[0];
    if (!fichier) return this.clear();
    this.nameTarget.textContent = fichier.name;
    this.chipTarget.hidden = false;
  }

  clear() {
    // ⚠️ `value = ""` et non `files = null` : un `input[type=file]` ne se vide que par là,
    // et sans ce vidage le même fichier repartirait avec la question SUIVANTE.
    this.inputTarget.value = "";
    this.chipTarget.hidden = true;
  }

  // Après l'envoi : la pièce est partie, le composeur repart nu.
  reset() {
    this.clear();
  }
}
